import Vue from 'vue'
import App from './App.vue'
import router from "./route"
import store from './store';
import "../../assets/js/flexablePhone"
// import "../../assets/js/swiper/swiper-bundle.min.js"
// import "../../assets/js/swiper/swiper-bundle.min.css"
import { Message,scrollbar,InfiniteScroll,Row,Col,Input} from 'element-ui';
// 移动端调试工具
// import VConsole from 'vconsole';
// const vConsole = new VConsole();
Vue.config.productionTip = false

Vue.prototype.$message = Message;
Vue.use(scrollbar)
Vue.use(InfiniteScroll)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
